module.exports = __webpack_public_path__ + "static/media/qr-code.1cb7211a.svg";